import * as React from "react";

type Theme = "light" | "dark";

const getInitialTheme = (): Theme => {
  if (typeof document === "undefined") return "light";

  const attr = document.documentElement.getAttribute(
    "data-theme"
  ) as Theme | null;
  if (attr === "light" || attr === "dark") return attr;

  // Fallbacks if that script wasn't able to run
  const storedTheme = window.localStorage.getItem("theme") as Theme | null;
  if (storedTheme === "light" || storedTheme === "dark") return storedTheme;

  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
};

export const useTheme = () => {
  const [theme, setTheme] = React.useState<Theme>(() => getInitialTheme());

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.localStorage.setItem("theme", theme);
  }, [theme]);

  return { theme, setTheme };
};
